/* eslint-disable class-methods-use-this, import/no-cycle */
import { LitElement, render } from 'lit';
import store from '@mfe/store';
import config from '@mfe/config';
import { templates } from '@mfe/components/templates'; // eslint-disable-line import/no-cycle
import { TemplatingMixin } from '@mfec/lit/mixins/TemplatingMixin';
import { createCustomerAttributeInteraction } from '@mfec/customerAttributes/createCustomerAttributeInteraction';
import { replaceO2SpanWithAirFontLigature } from '@mfec/utils/dsone/replaceO2SpanWithAirFontLigature';

type TargetType = ShadowRoot | typeof this | HTMLElement;

class LitElementExtended extends TemplatingMixin(LitElement, 'occl', templates) {
  static get version() {
    const { version } = config;
    return version;
  }

  static get build() {
    return {
      target: '__buildTarget__',
      date: '__buildDate__',
    };
  }

  replaceElements() {
    const { config: { occluri } } = store.getState();
    const isOcclTheme = !!occluri;
    this.setTemplatingTheme(isOcclTheme ? 'occl' : 'tefOne');

    const target = this.shadowRoot || this;

    createCustomerAttributeInteraction(target);
    this.createTooltipInteraction(target);

    if (!isOcclTheme) {
      this.replaceLinkTags(target);
      replaceO2SpanWithAirFontLigature(target);

      this.replaceElementsInTefOneTemplate(target, 'emTemplate', 'em');
      this.replaceElementsInTefOneTemplate(target, 'comsP1Template', 'div.coms-paragraph-1');
      this.replaceElementsInTefOneTemplate(target, 'comsP2Template', 'div.coms-paragraph-2');
      this.replaceElementsInTefOneTemplate(target, 'comsP3Template', 'div.coms-paragraph-3');
      this.replaceElementsInTefOneTemplate(target, 'comsText1Template', 'span.coms-text-1');
      this.replaceElementsInTefOneTemplate(target, 'comsText2Template', 'span.coms-text-2');
      this.replaceElementsInTefOneTemplate(target, 'comsText3Template', 'span.coms-text-3');
    }
  }

  replaceElementsInTefOneTemplate(
    target : TargetType,
    templateName: string,
    selector: string,
  ) {
    const templateFn = this.getTemplateFn(templateName);
    target.querySelectorAll(selector).forEach((node) => {
      const target$ = new DocumentFragment();
      render(templateFn(node), target$);
      node.replaceWith(target$);
    });
  }

  replaceLinkTags(target: TargetType) {
    const linkTemplate = this.getTemplateFn('linkTemplate');
    target.querySelectorAll('a').forEach((node) => {
      const oneLink$ = new DocumentFragment();
      render(linkTemplate(node), oneLink$);
      node.replaceWith(oneLink$);
    });
  }

  createTooltipInteraction(target: TargetType) {
    const { config: { stylecontext } } = store.getState();
    const tooltipTemplate = this.getTemplateFn('tooltipTemplate');
    const allAbbr: NodeListOf<HTMLElement> = target.querySelectorAll('[title]');
    allAbbr.forEach((node) => {
      const target$ = new DocumentFragment();
      render(tooltipTemplate(stylecontext, node), target$);
      node.replaceWith(target$);
    });
  }
}

export default LitElementExtended;
